import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import axios from "axios";
import "./BannerSlider.css";

export default function BannerSlider() {
  const sliderRef = useRef(null);
  const [desktopBanners, setDesktopBanners] = useState([]);
  const [mobileBanners, setMobileBanners] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await axios.get(
          "https://admin.cmpranesh-admk.com/api/getHomeBanners.php"
        );

        setDesktopBanners(res.data.desktop);
        setMobileBanners(res.data.mobile);
      } catch (err) {
        console.error("Error fetching banner images:", err);
      }
    };

    fetchBanners();

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const bannersToShow = isMobile ? mobileBanners : desktopBanners;

  return (
    <div className="cm-banner-wrapper">
      <Slider
        ref={sliderRef}
        dots={false}
        infinite
        autoplay
        speed={1300}
        slidesToShow={1}
        slidesToScroll={1}
        arrows={false}
        fade
      >
        {bannersToShow.map((img, index) => (
          <div key={index} className="cm-banner-slide">
            <img
              src={`${
                isMobile
                  ? "https://admin.cmpranesh-admk.com/uploads/HomeBannerMobile/"
                  : "https://admin.cmpranesh-admk.com/uploads/HomeBanner/"
              }${img}`}
              alt={`Slide-${index}`}
              className="cm-slide-img"
            />
          </div>
        ))}
      </Slider>

      <div className="cm-slider-controls">
        <button
          onClick={() => sliderRef.current.slickPrev()}
          className="cm-arrow-btn"
        >
          ←
        </button>
        <button
          onClick={() => sliderRef.current.slickNext()}
          className="cm-arrow-btn"
        >
          →
        </button>
      </div>
    </div>
  );
}
